module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.gameInfo['showDown'] === 2) ? _c('van-row', {
    staticClass: "banner-panel"
  }, [_c('img', {
    attrs: {
      "src": _vm.entityFileMain + '/' + _vm.gameInfo['noDownPage']
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.gameInfo['showDown'] === 1) ? _c('van-row', [(this.isSetString(_vm.gameInfo['landingPage'])) ? _c('van-row', {
    staticClass: "banner-panel"
  }, [_c('img', {
    attrs: {
      "src": _vm.entityFileMain + '/' + _vm.gameInfo['landingPage']
    }
  })]) : _vm._e(), _vm._v(" "), _c('van-row', {
    staticClass: "icon-panel"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.entityFileMain + '/' + _vm.gameInfo['gameIcon']
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "content"
  }, [_c('van-row', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.gameInfo['gameName']))]), _vm._v(" "), _c('van-row', {
    staticClass: "tag"
  }, [(this.isSetString(_vm.gameInfo['tagOne'])) ? _c('span', [_vm._v(_vm._s(_vm.gameInfo['tagOne']))]) : _vm._e(), _vm._v(" "), (this.isSetString(_vm.gameInfo['tagTwo'])) ? _c('span', [_vm._v(_vm._s(_vm.gameInfo['tagTwo']))]) : _vm._e(), _vm._v(" "), (this.isSetString(_vm.gameInfo['tagThree'])) ? _c('span', [_vm._v(_vm._s(_vm.gameInfo['tagThree']))]) : _vm._e()]), _vm._v(" "), _c('van-row', {
    staticClass: "info"
  }, [_c('span', [_vm._v(_vm._s(_vm.gameInfo['downloads']))]), _vm._v("人在玩")]), _vm._v(" "), _c('van-row', {
    staticClass: "btns"
  }, [(this.isSetString(_vm.gameInfo['isH5'])) ? _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.playH5Game();
      }
    }
  }, [_vm._v("开始游戏")]) : _vm._e(), _vm._v(" "), (_vm.gameInfo['showDownBtn'] === 1) ? _c('div', {
    staticClass: "item download",
    on: {
      "click": function($event) {
        return _vm.downloadGame();
      }
    }
  }, [_vm._v("下载游戏")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('van-row', {
    staticClass: "game-about"
  }, [_c('van-row', {
    staticClass: "title"
  }, [_vm._v("游戏简介")]), _vm._v(" "), _c('van-row', {
    class: ['content', _vm.isMore && 'show']
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.gameInfo['describe'])
    }
  }), _vm._v(" "), (!_vm.isMore) ? _c('div', {
    staticClass: "more",
    on: {
      "click": _vm.handleMore
    }
  }, [_c('span', [_vm._v("...")]), _vm._v("更多")]) : _vm._e()]), _vm._v(" "), _c('van-row', {
    staticClass: "pic-view"
  }, _vm._l((_vm.gameInfo['screenshot']), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.handlePreview(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.entityFileMain + '/' + item
      }
    })])
  }), 0), _vm._v(" "), _c('p', [_vm._v("\n        网站备案：" + _vm._s(_vm.webData.webNum) + " © " + _vm._s(_vm.webData.WebCompany) + "\n      ")])], 1), _vm._v(" "), _c('van-row', {
    staticClass: "footer-panel"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.entityFileMain + '/' + _vm.gameInfo['gameIcon']
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.gameInfo['gameName']))]), _vm._v(" "), _c('van-col', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "download",
    on: {
      "click": function($event) {
        return _vm.downloadGame()
      }
    }
  }, [_vm._v("下载游戏")])])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-122eb411"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPage/MainGameInfo.vue
// module id = 303
// module chunks = 0 1 2 3